import { isEmpty } from 'lodash'

import { FIELD_VALUE_TYPE, SEARCH_FIELD_TYPE } from '@constants'
import { POSTCreateSearchType } from '@types'

export const transformSearchFilterDailyRangeField = (
  createSearchFilterPayload: POSTCreateSearchType
): POSTCreateSearchType => {
  return {
    ...createSearchFilterPayload,
    storedSearchFilters: createSearchFilterPayload.storedSearchFilters?.map(searchFilter => {
      if (!searchFilter) return searchFilter

      return {
        ...searchFilter,
        storedValues: searchFilter.storedValues?.map(storedValue => {
          if (!storedValue) return storedValue
          if (
            storedValue.valueType === FIELD_VALUE_TYPE.DATETIME &&
            storedValue.fieldType === SEARCH_FIELD_TYPE.DAILY_RANGE &&
            !isEmpty(storedValue.dailyRange)
          ) {
            // убираем dailyRange, valueType, fieldType
            const {
              dailyRange: _dailyRange,
              valueType: _valueType,
              fieldType: _fieldType,
              ...transformStoredValue
            } = storedValue

            return {
              ...transformStoredValue,
              value: JSON.stringify(storedValue.dailyRange.label),
            }
          }
          const {
            dailyRange: _dailyRange,
            valueType: _valueType,
            fieldType: _fieldType,
            ...transformStoredValue
          } = storedValue

          return transformStoredValue
        }),
      }
    }),
  } as POSTCreateSearchType
}
